import { Head } from "@inertiajs/react";
import { t } from "@travily/i18n";
import { creatorListingsPath, serviceCreatorStagePath } from "@travily/routes";
import type ListingsCreatorTitle from "@travily/types/pages/ListingsCreatorTitle";
import { useCreatorTopBarActions } from "@/lib/wizard/use-creator-top-bar-actions";
import { useWizardForm } from "@/lib/wizard/use-wizard-form";
import { ServiceTitleStepView } from "./show.view";

type PageProps = ListingsCreatorTitle;

type FormData = {
  title: string;
};

const ServiceTitleStep = ({ listing_id, stage_index, stage_order, title }: PageProps) => {
  const { bindField, currentStage, totalStages, onBack, onPrimary, primaryPending } = useWizardForm<FormData>({
    routes: {
      stageUrl: (stage) => serviceCreatorStagePath(listing_id, stage),
      entryUrl: creatorListingsPath(),
    },
    stageName: "title",
    stageIndex: stage_index,
    stageOrder: stage_order,
    initialData: { title: title ?? "" },
  });

  // validateOn "change" so the model's title length validation surfaces live (debounced) through
  // precognition as the user types, rather than only on blur.
  const titleField = bindField("title", { validateOn: "change" });

  const topBarActions = useCreatorTopBarActions({ saveHref: creatorListingsPath() });

  return (
    <>
      <Head title={t("web.services.creator.steps.title.show.meta_title")}>
        <meta name="description" content={t("web.services.creator.steps.title.show.meta_description")} />
      </Head>
      <ServiceTitleStepView
        currentStage={currentStage}
        totalStages={totalStages}
        onBack={onBack}
        topBarActions={topBarActions}
        onPrimary={onPrimary}
        primaryPending={primaryPending}
        value={titleField.value}
        error={titleField.errorMessage}
        onChange={titleField.onChange}
        onBlur={titleField.onBlur}
      />
    </>
  );
};

export default ServiceTitleStep;
